import { Box, Tab, Tabs, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import Students from "./Students";
import PendingFees from "./PendingFees";
import Revenue from "./Revenue";
import Expenses from "./Expenses";
import ExpensesVsRevenue from "./ExpensesVsRevenue";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAcademicSessions,
  selectAllSessions,
  selectSessionsLoading,
  selectSessionsError,
} from "../../../Slices/sessionsSlice";

function HomeData() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAcademicSessions());
  }, [dispatch]);

  const [tabValue, setTabValue] = useState(0);
  const schoolId = sessionStorage.getItem("schoolId");
  const sessions = useSelector(selectAllSessions);
  const sessionsLoading = useSelector(selectSessionsLoading);
  const sessionsError = useSelector(selectSessionsError);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} centered>
        <Tab label="Students" sx={{ textTransform: "capitalize" }} />
        <Tab label="Pending Fee" sx={{ textTransform: "capitalize" }} />
        <Tab label="Expenses" sx={{ textTransform: "capitalize" }} />
        <Tab label="Revenue" sx={{ textTransform: "capitalize" }} />
        <Tab label="Revenue Vs Expense" sx={{ textTransform: "capitalize" }} />
      </Tabs>

      <Box sx={{ p: 2 }}>
        {tabValue === 0 && (
          <Card
            sx={{
              height: "450px",
              overflow: "auto",
            }}
          >
            <Students
              schoolId={schoolId}
              sessions={sessions}
              sessionsError={sessionsError}
              sessionsLoading={sessionsLoading}
            />
          </Card>
        )}
        {tabValue === 1 && (
          <Card
            sx={{
              height: "450px",
              overflow: "auto",
            }}
          >
            <PendingFees schoolId={schoolId} sessions={sessions} />
          </Card>
        )}
        {tabValue === 2 && (
          <Card
            sx={{
              height: "450px",
              overflow: "auto",
            }}
          >
            <Expenses
              schoolId={schoolId}
              sessions={sessions}
              sessionsError={sessionsError}
              sessionsLoading={sessionsLoading}
            />
          </Card>
        )}
        {tabValue === 3 && (
          <Card
            sx={{
              height: "450px",
              overflow: "auto",
            }}
          >
            <Revenue
              schoolId={schoolId}
              sessions={sessions}
              sessionsError={sessionsError}
              sessionsLoading={sessionsLoading}
            />
          </Card>
        )}
        {tabValue === 4 && (
          <Card
            sx={{
              height: "450px",
              overflow: "auto",
            }}
          >
            <ExpensesVsRevenue
              schoolId={schoolId}
              sessions={sessions}
              sessionsError={sessionsError}
              sessionsLoading={sessionsLoading}
            />
          </Card>
        )}
      </Box>
    </>
  );
}

export default HomeData;
